import { Link } from 'react-router-dom';
import Logo from './Logo';

const domainLinkClass = 'text-sm tracking-wide text-background/70 hover:text-background transition-opacity underline-offset-4 hover:underline';

const Footer = () => {
  const handleNavClick = () => {
    window.scrollTo(0, 0);
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background">
      {/* Tagline Banner */}
      <div className="bg-sage py-4">
        <p className="text-center text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] text-sage-foreground font-semibold px-4">
          MORE VIEWS • NEW WAYS • INSPIRED OUTCOMES
        </p>
      </div>
      
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-10 sm:py-12">
        {/* Mobile: Editorial left-aligned layout with sectioned columns */}
        <div className="md:hidden">
          {/* Brand */}
          <div className="mb-8">
            <div className="mb-3"><Logo variant="reversed" height={56} /></div>
            <p className="text-[0.65rem] uppercase tracking-[0.22em] text-background/50 mb-4">Human capacity. Developed.</p>
            <p className="text-sm leading-relaxed text-background/70 max-w-sm">
              Developmental coaching for the human side of AI transformation.
            </p>
          </div>

          {/* Two-column: Explore + Connect, cleanly aligned */}
          <div className="grid grid-cols-[1fr_1.15fr] gap-x-5 gap-y-8 mb-8">
            <div>
              <h4 className="text-[0.7rem] font-semibold text-background uppercase tracking-[0.2em] mb-3">Explore</h4>
              <nav className="flex flex-col space-y-2">
                <Link to="/" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Home</Link>
                <Link to="/ai-transformation" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">AI Transformation</Link>
                <Link to="/about" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">About</Link>
                <Link to="/services" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">For Leaders</Link>
                <Link to="/for-organizations" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">For Organizations</Link>
                <Link to="/testimonials" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Results</Link>
                <Link to="/essays" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Essays</Link>
              </nav>
            </div>
            <div>
              <h4 className="text-[0.7rem] font-semibold text-background uppercase tracking-[0.2em] mb-3">Connect</h4>
              <div className="flex flex-col space-y-2 text-sm text-background/70">
                <a href="mailto:support@paradoxedge.com" className="hover:text-background transition-colors break-words">support@paradoxedge.com</a>
                <span>Denver, CO</span>
              </div>
              <div className="mt-4 flex flex-col space-y-2">
                <a href="https://kenthfrazier.com" target="_blank" rel="noopener noreferrer" className={domainLinkClass}>kenthfrazier.com</a>
                <span className="text-sm tracking-wide text-background/70">paradoxedge.com</span>
                <a href="https://fullyhuman.ai" target="_blank" rel="noopener noreferrer" className={domainLinkClass}>
                  fullyhuman<span className="text-primary">.ai</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-background/10 pt-5 flex flex-col gap-2">
            <div className="flex items-center gap-5">
              <Link to="/terms" onClick={handleNavClick} className="text-xs text-background/50 hover:text-background/70 transition-colors">Terms</Link>
              <Link to="/privacy" onClick={handleNavClick} className="text-xs text-background/50 hover:text-background/70 transition-colors">Privacy</Link>
            </div>
            <p className="text-xs text-background/50">&copy; {currentYear} ParadoxEdge. All rights reserved.</p>
          </div>
        </div>

        {/* Desktop: Three-column grid */}
        <div className="hidden md:grid md:grid-cols-[1.2fr_1fr_1fr] gap-12">
          {/* Brand */}
          <div className="flex flex-col">
            <div className="mb-3"><Logo variant="reversed" height={56} /></div>
            <p className="text-[0.65rem] uppercase tracking-[0.22em] text-background/50 mb-4">Human capacity. Developed.</p>
            <p className="text-sm leading-relaxed text-background/70">
              We facilitate individual, team, and organizational transformation through
              developmental coaching and a life of ongoing practice.
            </p>
          </div>

          {/* Navigation */}
          <div className="flex flex-col">
            <h4 className="text-sm font-semibold text-background uppercase tracking-wider mb-4">Explore</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Home</Link>
              <Link to="/ai-transformation" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">AI Transformation</Link>
              <Link to="/about" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">About</Link>
              <Link to="/services" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">For Leaders</Link>
              <Link to="/for-organizations" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">For Organizations</Link>
              <Link to="/testimonials" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Results</Link>
              <Link to="/essays" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Essays</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="flex flex-col">
            <h4 className="text-sm font-semibold text-background uppercase tracking-wider mb-4">Connect</h4>
            <div className="flex flex-col space-y-2 text-background/70">
              <a href="mailto:support@paradoxedge.com" className="hover:text-background transition-colors">support@paradoxedge.com</a>
              <span>Denver, CO</span>
            </div>
            <div className="mt-4 flex flex-col space-y-2">
              <a href="https://kenthfrazier.com" target="_blank" rel="noopener noreferrer" className={domainLinkClass}>kenthfrazier.com</a>
              <span className="text-sm tracking-wide text-background/70">paradoxedge.com</span>
              <a href="https://fullyhuman.ai" target="_blank" rel="noopener noreferrer" className={domainLinkClass}>
                fullyhuman<span className="text-primary">.ai</span>
              </a>
            </div>
          </div>
        </div>

        {/* Desktop Bottom Bar */}
        <div className="hidden md:flex border-t border-background/10 mt-10 pt-4 items-center justify-between">
          <p className="text-sm text-background/50">&copy; {currentYear} ParadoxEdge. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <Link to="/terms" onClick={handleNavClick} className="text-sm text-background/50 hover:text-background/70 transition-colors">Terms of Service</Link>
            <Link to="/privacy" onClick={handleNavClick} className="text-sm text-background/50 hover:text-background/70 transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
